import { Component, input } from '@angular/core';
import { SvgIconComponent } from '../../../../common-components/svg-icon/svg-icon.component';
import { SettingOption } from '../../../../interfaces/settings-option.interface';
import { TranslocoDirective } from '@jsverse/transloco';

@Component({
  selector: 'app-settings-option',
  standalone: true,
  imports: [
    SvgIconComponent,
    TranslocoDirective
  ],
  templateUrl: './settings-option.component.html',
  styleUrl: './settings-option.component.scss'
})
export class SettingsOptionComponent<T> {
  public option = input.required<SettingOption<T>>();
}
